import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  width: 48px;

  color: var(--icon-secondary);
  cursor: pointer;

  &:hover {
    color: var(--icon-primary);
  }
`;
